import { createContext } from 'react';

type CollapsibleContextType = {
  toggle: () => void;
  open: boolean;
};

export const CollapsibleStateContext = createContext<CollapsibleContextType | undefined>(undefined);
